// frontend/src/components/production-sequence/RecalcDeltaBadge.tsx
// Badge inline del delta de días tras recalcular. delta>0 = adelanto (verde),
// delta<0 = retraso (rojo), delta===0 = no se renderiza.
interface Props { delta: number; dark: boolean; }

export function RecalcDeltaBadge({ delta, dark }: Props) {
  if (delta === 0) return null;
  const adelanto = delta > 0;
  const label = adelanto ? `+${delta}d ↑` : `${delta}d ↓`;
  const colorClass = dark
    ? (adelanto ? 'bg-emerald-900/50 text-emerald-300' : 'bg-red-900/50 text-red-300')
    : (adelanto ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600');
  return (
    <span className={`ml-1 inline-flex items-center px-1 py-0.5 rounded text-[10px] font-bold ${colorClass}`}>
      {label}
    </span>
  );
}
